import { Link, useParams, Navigate } from "react-router-dom";
import { SERVICES } from "@/data/services";
import SectionLabel from "@/components/SectionLabel";
import { Calendar, MessageCircle, ChevronLeft } from "lucide-react";
import { waLink } from "@/lib/clinic";

export default function ServiceDetail() {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/services" replace />;

  return (
    <div>
      <section className="py-14 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <Link to="/services" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#0A6EBD]">
            <ChevronLeft className="h-4 w-4" /> All services
          </Link>
          <div className="mt-6 flex items-start gap-5">
            <div className="h-14 w-14 rounded-2xl grid place-items-center text-white shrink-0"
                 style={{ background: "linear-gradient(135deg,#0A6EBD,#16A5B8)" }}>
              <s.icon className="h-6 w-6" />
            </div>
            <div>
              <SectionLabel>Service</SectionLabel>
              <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900">{s.title}</h1>
              <p className="mt-3 text-slate-600 max-w-2xl leading-relaxed">{s.overview}</p>
            </div>
          </div>

          <div className="mt-10 grid md:grid-cols-2 gap-6">
            <div className="rounded-2xl border border-slate-200/70 p-6 aarogya-shadow bg-white">
              <div className="text-[11px] font-bold tracking-[0.24em] uppercase text-teal-600 mb-2">Common Symptoms</div>
              <ul className="space-y-2 text-slate-700">
                {s.symptoms.map((x, i) => (
                  <li key={i} className="flex items-start gap-2"><span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#0A6EBD]"></span>{x}</li>
                ))}
              </ul>
            </div>
            <div className="rounded-2xl border border-slate-200/70 p-6 aarogya-shadow bg-white">
              <div className="text-[11px] font-bold tracking-[0.24em] uppercase text-teal-600 mb-2">Benefits</div>
              <ul className="space-y-2 text-slate-700">
                {s.benefits.map((x, i) => (
                  <li key={i} className="flex items-start gap-2"><span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#16A5B8]"></span>{x}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 rounded-3xl p-8 text-white aarogya-shadow"
               style={{ background: "linear-gradient(135deg,#0A6EBD,#3F2D86)" }}>
            <div className="font-serif text-2xl">Ready to consult about {s.title.toLowerCase()}?</div>
            <p className="text-white/80 mt-2 text-sm">Book online or reach us on WhatsApp — we usually reply within minutes.</p>
            <div className="mt-4 flex flex-wrap gap-3">
              <Link to="/appointment" className="inline-flex items-center gap-2 rounded-full bg-white text-[#0A6EBD] px-5 py-3 text-sm font-semibold"
                    data-testid={`service-book-${s.slug}`}>
                <Calendar className="h-4 w-4" /> Book Appointment
              </Link>
              <a href={waLink(`Hi, I want to consult for ${s.title}`)} target="_blank" rel="noreferrer"
                 className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 text-white px-5 py-3 text-sm font-semibold">
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
